export const getFieldsConfiguration = ({ register, errors, values, config }) =>
	Object.freeze({
		ACCEPT_MARKETING_CONSENTS: {
			FIELD: register("acceptMarketingConsents", {
				value: values.acceptMarketingConsents,
				validate: {
					isOtherSelected: (value) => {
						if (
							!config.enableClubAgreementConsent &&
							values?.accept3rdPartyMarketingConsents &&
							!value
						) {
							return "komid.register.business.consents.accept.error.message";
						}
						return null;
					},
				},
			}),
			ERROR: errors?.acceptMarketingConsents?.message,
		},
		ACCEPT_3RD_PARTY_MARKETING_CONSENTS: {
			FIELD: register("accept3rdPartyMarketingConsents", {
				value: values.accept3rdPartyMarketingConsents,
				validate: {
					isOtherSelected: (value) => {
						if (
							!config.enableClubAgreementConsent &&
							values?.acceptMarketingConsents &&
							!value
						) {
							return "komid.register.business.consents.accept.error.message";
						}
						return null;
					},
				},
			}),
			ERROR: errors?.accept3rdPartyMarketingConsents?.message,
		},
		ACCEPT_SMS_NOTIFICATION: {
			FIELD: register("acceptSmsNotifications", {
				value: values.acceptSmsNotifications,
				validate: {
					isOtherSelected: (value) => {
						const oldConsentsEmpty =
							!config.enableClubAgreementConsent &&
							(!values?.acceptMarketingConsents ||
								!values?.accept3rdPartyMarketingConsents);
						const newConsentsEmpty =
							config.enableClubAgreementConsent &&
							!values?.acceptClubAgreementConsents;

						if (value && (oldConsentsEmpty || newConsentsEmpty)) {
							return "komid.register.business.consents.accept.sms.error.message";
						}
						return null;
					},
				},
			}),
			ERROR: errors?.acceptSmsNotifications?.message,
		},
		ACCEPT_CLUB_AGREEMENT_CONSENTS: {
			FIELD: register("acceptClubAgreementConsents", {
				value: values.acceptClubAgreementConsents,
			}),
			ERROR: errors?.acceptClubAgreementConsents?.message,
		},
	});
